import React from 'react';

import { AnimatedNumber } from 'src/components/common/AnimatedNumber';
import { Socials } from 'src/components/common/Socials';
import { useAppContext } from 'src/context/AppContext';

import iconAirplane from '../assets/airplane.svg';
import iconMako from '../assets/mako-logo-white.svg';
import iconTank from '../assets/tank.svg';

import css from './HeroStats.module.scss';

const texts = {
  percentLabel: 'מחיי עברו בזמן מלחמה',
  makoAlt: 'mako',
  shareLabel: 'שתפו:',
  daysLabel: 'ימי לחימה',
  warsLabel: 'מלחמות',
  operationsLabel1: 'מבצעים צבאיים',
  terrorLabel1: 'גלי<br />טרור',
};

export const HeroStats = () => {
  const NUMBER_ANIMATION_DURATION = 2_000;
  const { personalStats } = useAppContext();

  if (!personalStats) {
    return null;
  }

  return (
    <section className={css.heroStats} dir="rtl">
      <div className={css.sectionPercent}>
        <div className={css.statMain}>
          <div className={css.valueWrap}>
            <AnimatedNumber
              className={css.value}
              value={personalStats.stats.percentage}
              time={NUMBER_ANIMATION_DURATION}
              suffix="%"
            />
          </div>
          <div className={css.labelRow}>
            <img className={css.labelIcon} src={iconTank} alt="" width={47} height={22} />
            <p className={css.label}>{texts.percentLabel}</p>
          </div>
        </div>

        <div className={css.sectionPercentFooter}>
          <img className={css.makoLogo} src={iconMako} alt={texts.makoAlt} width={76} height={38} />
          <div className={css.share}>
            <span className={css.shareLabel}>{texts.shareLabel}</span>
            <Socials className={css.shareSocials} type="results" />
          </div>
        </div>
      </div>

      <div className={css.sectionDays}>
        <div className={css.statMain}>
          <div className={css.valueWrap}>
            <AnimatedNumber
              className={css.value}
              startValue={personalStats.stats.warTimeDays * 0.95}
              value={personalStats.stats.warTimeDays}
              time={NUMBER_ANIMATION_DURATION}
            />
          </div>
          <div className={css.labelRow}>
            <img className={css.labelIcon} src={iconAirplane} alt="" width={29} height={31} />
            <p className={css.label}>{texts.daysLabel}</p>
          </div>
        </div>
      </div>

      <div className={css.sectionRings}>
        <div className={css.rings}>
          <div className={css.ring}>
            <div className={css.ringValueWrap}>
              <AnimatedNumber
                className={css.ringValue}
                value={personalStats.stats.wars}
                time={NUMBER_ANIMATION_DURATION}
              />
            </div>
            <div className={css.ringLabel}>
              <p>{texts.warsLabel}</p>
              <p> </p>
            </div>
          </div>

          <div className={css.ring}>
            <div className={css.ringValueWrap}>
              <AnimatedNumber
                className={css.ringValue}
                value={personalStats.stats.militaryOperations}
                time={NUMBER_ANIMATION_DURATION}
              />
            </div>
            <div className={css.ringLabel}>
              <p>{texts.operationsLabel1}</p>
            </div>
          </div>

          <div className={css.ring}>
            <div className={css.ringValueWrap}>
              <AnimatedNumber
                className={css.ringValue}
                value={personalStats.stats.terroristOperations}
                time={NUMBER_ANIMATION_DURATION}
              />
            </div>
            <div className={css.ringLabel}>
              <p dangerouslySetInnerHTML={{ __html: texts.terrorLabel1 }} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroStats;
